import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { ITimelineState } from '../store/timeline.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { setSaveTimelineResponse } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { updateCustomGroupsFromTimeLine } from '../../nemsisData/store/nemsisCustomData.actions'
import { StateCustomDataConstants } from '../../nemsisData/store/nemsisCustomData.constants'

export function* saveTimelineItems() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const timelineItems = items

  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)

  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient, timelineItems } }
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setSaveTimelineResponse(response))
      yield put(updateCustomGroupsFromTimeLine(StateCustomDataConstants.ADD_TIMELINE_GROUP))
    } catch (e) {
      yield put(throwPcrException(`saveTimeline() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveTimelineItemsSaga() {
  yield takeLatest([TimelineConstants.SAVE_TIMELINE], performWithMutexHOG, saveTimelineItems)
}
